// extracted by mini-css-extract-plugin
module.exports = {"articleCard":"_1SuWL","illustration":"_2aNgG","link":"_2Qqla","title":"dE1bC","geoTag":"_3GhvT","pin":"_1yx8g","discover":"jgie1","date":"_1H_GE","text":"_3u2da"};